module.exports = __webpack_public_path__ + "img/qrcode-checked.0f6303a2.png";